import React from 'react';


import ContactInfo from './../contact/contactInfo/contactInfo';
import ContactSocial from './../contact/contactInfo/contactSocial';

const FooterContact = () => {

    return (
        <>
            {/* <VisiterCount /> */}
            <ContactInfo />
            <ContactSocial />
        </>
    )
}

export default FooterContact;